import React, { useMemo, memo, useState, useEffect } from 'react';
import style from './index.module.scss';
import { getFactoryList } from '@/apis';
import { useQuery } from '@tanstack/react-query';
import { Spin, Empty, Checkbox } from 'antd';
// import type { InferArrayValue } from '@/types/infer';
import FatorBox from '../../components/FatorBox';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';

// type IPItemType = InferArrayValue<
//   NonNullable<Awaited<ReturnType<typeof getFactoryList>>['data']>
// >;

interface Props {
  initValue: CheckboxValueType[];
  changeFator: (fator: { factory__in: string | undefined }) => void;
}

const FactoryList: React.FC<Props> = ({ changeFator, initValue }) => {
  const [value, setValue] = useState<CheckboxValueType[]>([]);
  const { data: factoryList, isFetching } = useQuery(
    [getFactoryList.name],
    async () => {
      const res = await getFactoryList({
        page: 1,
        page_size: 500,
      });
      const list = res.data?.list || [];
      return list;
    },
  );
  const checkList = useMemo(() => {
    if (factoryList && factoryList.length) {
      return factoryList.map((item) => ({
        label: item.name,
        value: item.name!,
      }));
    }
    return [];
  }, [factoryList]);
  const changeFactory = (list: CheckboxValueType[]) => {
    setValue(list);
    changeFator({
      factory__in: list.join('|'),
    });
  };
  const reload = () => {
    setValue([]);
    changeFator({
      factory__in: undefined,
    });
  };
  useEffect(() => {
    setValue(initValue);
  }, [initValue]);
  return (
    <FatorBox title="Factory" reload={reload}>
      <div className={style.ips}>
        <Spin className="center-loading" delay={300} spinning={isFetching} />
        {factoryList && factoryList.length > 0 && (
          <Checkbox.Group
            className={style.group}
            options={checkList}
            onChange={changeFactory}
            defaultValue={initValue}
            value={value}
          />
        )}
        {factoryList && factoryList.length === 0 && <Empty />}
      </div>
    </FatorBox>
  );
};

export default memo(FactoryList);
